<template>
<div class="Accounting">
  <v-content class="db-content">
    <v-container fluid grid-list-xl >
    <sequential-entrance fromTop>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="useroptions" style="padding:15px;">
            <v-avatar size="50px" tile>
              <img alt="Avatar" src="@/assets/john.jpg" />
            </v-avatar>
            <label class="headline" style="margin-left:20px">John Salinas</label>
<!--
   <sequential-entrance delay="3000">

          <Search class="m-left" />

   </sequential-entrance>   -->

            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              elevation="10"
              :max-width="300"
              min-height="130"
            >

              <template v-slot:activator="{ off }">


                <div v-on="on" class="three-dot">
   <v-toolbar-title>Accounting</v-toolbar-title>
                   <v-spacer></v-spacer>
                </div>

              </template>

              <v-card>
                <v-list rounded>
                  <v-list-item-group v-model="item" color="primary">
                    <v-list-item v-for="(item, i) in items" :key="i" @click="nav(item.nav)">
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>

                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-card>
        </v-flex>
      </v-layout>
    </sequential-entrance>
        <v-flex class="spacer3"></v-flex>
    <sequential-entrance fromRight>
  <div class="navigate" >
    <v-container >
      <v-layout row wrap>
         <v-flex
        sm6
        xs6
        md6
        lg6
      >

        <v-btn class="ma-2" outlined color="teal" value="Go Back From Whence You Came!" onclick="history.back(-1)">Previous Page</v-btn>


         </v-flex>
         <v-flex
        sm6
        xs6
        md6
        lg6
      >
        <AccountingPopup class="ma-2" outlined color="teal" onclick="" style="float: right;" />

         </v-flex>
      </v-layout>
    </v-container>
  </div>

  <div class="team" >
    <v-container >
      <v-layout row wrap>
         <v-flex
        sm6
        xs12
        md12
        lg4
      >
       <v-card class="theme-bg-card-negative" >

          <AccountingGrade class="m-left" />


      </v-card>


         </v-flex>
         <v-flex
        sm6
        xs12
        md12
        lg4
      >
       <v-card class="theme-bg-card" >

          <AccountingInfo class="m-left" />

      </v-card>


         </v-flex>



         <v-flex
        sm6
        xs12
        md12
        lg4
      >
       <v-card class="theme-bg-card" >

      <sequential-entrance fromBottom>

        <v-flex class="spacer"></v-flex>
        <v-flex class="spacer"></v-flex>

                 <AccountingProgressBar class="m-center" />

        <v-flex class="spacer"></v-flex>
        <v-flex class="spacer"></v-flex>
      </sequential-entrance>


      </v-card>


         </v-flex>


         <v-flex
        sm6
        xs12
        md12
        lg12
      >
       <v-card class="theme-bg-card" >

          <AccountingTable class="m-left" />


      </v-card>


         </v-flex>
         <!-- <v-flex
        sm6
        xs12
        md12
        lg4
      >
       <v-card class="theme-bg-card" >

          <Quotes class="m-left" />

      </v-card>


         </v-flex>



         <v-flex
        sm6
        xs12
        md12
        lg4
      >
       <v-card class="theme-bg-card" >
          <Invoices class="m-left" />
      </v-card>


         </v-flex>


         <v-flex
        sm6
        xs12
        md12
        lg4
      >
       <v-card class="theme-bg-card" >


          <LineBar class="m-left" />



  <v-spacer></v-spacer>



  </v-card>
      </v-flex>
<v-flex
        sm6
        xs12
        md12
        lg4
      >
       <v-card class="theme-bg-card" >



          <LineChart class="m-left" />


  <v-spacer></v-spacer>


  </v-card>
      </v-flex>

         <v-flex
        sm6
        xs12
        md12
        lg4
      >
       <v-card class="theme-bg-card" >
          <Bar class="m-left" />
      </v-card>


         </v-flex>
     -->
      </v-layout>
    </v-container>
  </div>


       <v-layout row wrap>
        <v-flex xs12 sm12 md12 xl2 class="space2">

        </v-flex>
      </v-layout>


    </sequential-entrance>

        <div class="spacer">
        </div>


        <div class="spacer">
        </div>


        <div class="spacer">
        </div>


        <div class="spacer">
        </div>





    </v-container>




    <v-overlay :absolute="absolute" :value="overlay" opacity="0.85">
      <!-- <v-btn text small color="success" @click="showCard = false">X</v-btn> -->
      <v-btn class="mx-2 close-btn" fab dark small color="#ccc" @click="overlay = false">X</v-btn>
      <v-layout row wrap v-if="this.productDetails">
        <v-slide-scale-transition>
          <v-flex xs12 sm12 md6 xl2>
            <img src="@/assets/iphone11.png" class="product-animate product" />
          </v-flex>
        </v-slide-scale-transition>
        <v-flex xs12 sm12 md4 xl2>
          <v-list-item class="info-animate mb-margin">
            <v-list-item-content>
              <v-list-item-title class="display-1">iPhone 11 Pro</v-list-item-title>
              <v-list-item-subtitle class="headline">$ 500</v-list-item-subtitle>
              <v-list-item-subtitle class="headline">Available in Amazon</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="!this.productDetails">
        <v-flex>
          <AccountingProgressBar v-if="this.activeDetails.AccountingProgressBar" class="product-animate detail-card" />
          <Bar v-if="this.activeDetails.report" class="product-animate detail-card" />
          <Mail v-if="this.activeDetails.email" class="product-animate detail-card" />
          <Task v-if="this.activeDetails.task" class="product-animate detail-card" />
          <Calendar v-if="this.activeDetails.Calendar" class="product-animate detail-card" />
          <Weather v-if="this.activeDetails.Weather" class="product-animate detail-card" />
          <LineBar v-if="this.activeDetails.LineBar" class="product-animate detail-card" />
          <LineChart v-if="this.activeDetails.LineChart" class="product-animate detail-card" />
        </v-flex>
      </v-layout>
    </v-overlay>



  </v-content>
</div>

</template>



<script>
import AccountingTable from "@/components/AccountingTable.vue";
import AccountingPopup from "@/components/AccountingPopup.vue";
import AccountingProgressBar from "@/components/AccountingProgressBar.vue";
// import Search from "@/components/Search.vue";
//import Mail from "@/components/Mail.vue";
//import Task from "@/components/Task.vue";
//import Business from "@/components/Business.vue";
// import Quotes from "@/components/Quotes.vue";
// import Invoices from "@/components/Invoices.vue";
// import Churn from "@/components/Churn.vue";
import AccountingGrade from "@/components/AccountingGrade.vue";
import AccountingInfo from "@/components/AccountingInfo.vue";
import Bar from "@/components/Bar.vue";
import LineBar from "@/components/LineBar.vue";
import LineChart from "@/components/LineChart.vue";
//import Calendar from "@/components/Calendar.vue";
//import Weather from "@/components/Weather.vue";
//import carousel from "vue-owl-carousel";
//import "./node_modules/slick-carousel/slick/slick.css";
//import Slick from "vue-slick";
//import jQuery from "jquery";
//import { Carousel3d, Slide } from "vue-carousel-3d";
export default {
  name: "Accounting",
  components: {
    AccountingTable,
    AccountingPopup,
    AccountingProgressBar,
    // Search,
    //Mail,
    //Task,
    //Business,
    AccountingGrade,
    AccountingInfo,
    // Quotes,
    // Invoices,
    // Churn,
    Bar,
    LineBar,
    LineChart,
    //carousel,
    //Calendar,
    //Weather
  },
  data() {
    return {
      productDetails: false,
      activeDetails: {
        email: false,
        task: false,
        report: false,
        Calendar: false,
        Weather: false
      },
      absolute: true,
      overlay: false,
      title: "",
      icons: [
        { text: "Calendar", icon: "mdi mdi-calendar-today" },
        { text: "Email", icon: "mdi mdi-email" },
        { text: "Business", icon: "mdi mdi-chart-pie" },
        { text: "analytics", icon: "mdi mdi-chart-line" },
        { text: "Chat", icon: "mdi mdi-comment-processing-outline" },
        { text: "Bank", icon: "mdi mdi-bank" }
      ],
      item: 1,
      selectedItem: 1,
      menu: false,
      items: [

        { text: "Home", icon: "mdi-home", nav: "home" },
        { text: "Dashboard", icon: "mdi-view-dashboard", nav: "dashboard" },
        { text: "Training", icon: "mdi-cube-outline", nav: "training" },
        { text: "Sales", icon: "mdi-account", nav: "salesdepartment" },
        { text: "Appointments", icon: "mdi-calendar-text", nav: "appointments" },
        { text: "Forms", icon: "mdi-account-edit", nav: "forms" },
{
          text: "Sentimental Analysis",
          icon: "mdi-clock",
          nav: "sentimental-analysis"
        },
        { text: "Help", icon: "mdi-help", nav: "help" },
        { text: "Logout", icon: "mdi-flag", nav: "login" }
      ]
    };
  },
  methods: {
    next: () => {
      this.$refs.slick.next();
    },
    prev: () => {
      this.$refs.slick.prev();
    },
    handleDestroy: (event, slick) => {
      console.log('handleDestroy', event, slick);
    },
    close: () => {
     this.$refs.slick.mywindow.close();
    },
    reInit: () => {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick();
    },
    readOutLoud: msg => {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      // this.alert = "true";
    },
    nav(path) {
      this.$router.push({ name: path });
    },
    showCard() {
      console.log("Move to card");
      this.selectedItem = 4;
    },

  },
  mounted() {
    setTimeout(() => {
      this.readOutLoud(`Accounting`);
    }, 2000);

    Event.$on("command", data => {
      if (!data) return;

      this.overlay = true;
      this.productDetails = false;
      this.productDetailsclose = true;
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;

      if (
        data.msg.indexOf("emails") !== -1 ||
        data.msg.indexOf("email") !== -1 ||
        data.msg.indexOf("mails") !== -1
      ) {
        this.title = "Emails";
        console.log(data.msg);
        this.activeDetails.email = true;
        this.activeDetails.task = false;
        this.activeDetails.report = false;
        this.activeDetails.Calendar = false;
        this.activeDetails.Weather = false;



        speech.text = "Here's your mail's";
        // window.speechSynthesis.speak(speech);
        return;
      } else if (
        data.msg.indexOf("task") !== -1 ||
        data.msg.indexOf("tasks") !== -1
      ) {
        console.log(data.msg);
        this.title = "Tasks";
        speech.text = "Here's your task's";
        // window.speechSynthesis.speak(speech);
        this.activeDetails.email = false;
        this.activeDetails.task = true;
        this.activeDetails.report = false;
        this.activeDetails.Calendar = false;
        this.activeDetails.Weather = false;


        return;
      } else if (
        data.msg.indexOf("report") !== -1 ||
        data.msg.indexOf("reports") !== -1
      ) {
        console.log(data.msg);
        this.title = "Reports";
        speech.text = "Here's your report's";
        // window.speechSynthesis.speak(speech);
        this.activeDetails.email = false;
        this.activeDetails.task = false;
        this.activeDetails.Calendar = false;
        this.activeDetails.report = true;
        this.activeDetails.Weather = false;
        return;


      } else if (data.msg.indexOf("calendar") !== -1
      ) {
        console.log(data.msg);
        this.title = "Calendar";
        speech.text = "Here's your calendar";
        // window.speechSynthesis.speak(speech);
        this.activeDetails.email = false;
        this.activeDetails.task = false;
        this.activeDetails.report = false;
        this.activeDetails.Calendar = true;
        this.activeDetails.Weather = false;


        return;

      } else if (
        data.msg.indexOf("weather") !== -1
      ) {
        console.log(data.msg);
        this.title = "Weather";
        speech.text = "Here's your weather";
        // window.speechSynthesis.speak(speech);
        this.activeDetails.email = false;
        this.activeDetails.task = false;
        this.activeDetails.report = false;
        this.activeDetails.Calendar = false;
        this.activeDetails.Weather = true;

        return;

      }
      // window.speechSynthesis.speak(speech);
    });

    Event.$on("showProductDetails", () => {
      console.log("Show Product");
      this.overlay = true;
      this.productDetails = true;
    });
    Event.$off("closeProductDetails", () => {
      console.log("Close Product");
      this.overlay = false;
      this.productDetailsclose = false;
    });

window.onload = function () {
    "use strict";
    var paths = document.getElementsByTagName('path');
    var visualizer = document.getElementById('visualizer');
    var mask = visualizer.getElementById('mask');
    var h = document.getElementsByTagName('h1')[0];
    var path;


    var soundAllowed = function (stream) {
        //Audio stops listening in FF without // window.persistAudioStream = stream;
        //https://bugzilla.mozilla.org/show_bug.cgi?id=965483
        //https://support.mozilla.org/en-US/questions/984179
        window.persistAudioStream = stream;
        h.innerHTML = "Thanks";
        h.setAttribute('style', 'opacity: 0;');
        var audioContent = new AudioContext();
        var audioStream = audioContent.createMediaStreamSource( stream );
        var analyser = audioContent.createAnalyser();
        audioStream.connect(analyser);
        analyser.fftSize = 1024;

        var frequencyArray = new Uint8Array(analyser.frequencyBinCount);
        visualizer.setAttribute('viewBox', '0 0 255 255');

				//Through the frequencyArray has a length longer than 255, there seems to be no
        //significant data after this point. Not worth visualizing.
        for (var i = 0 ; i < 255; i++) {
            path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('stroke-dasharray', '4,1');
            mask.appendChild(path);
        }
      var doDraw = function () {
            requestAnimationFrame(doDraw);
            analyser.getByteFrequencyData(frequencyArray);
      var adjustedLength;
            for (var i = 0 ; i < 255; i++) {
      adjustedLength = Math.floor(frequencyArray[i]) - (Math.floor(frequencyArray[i]) % 5);
                paths[i].setAttribute('d', 'M '+ (i) +',255 l 0,-' + adjustedLength);
            }

        }
        doDraw();
    }

    var soundNotAllowed = function (error) {
        h.innerHTML = "You must allow your microphone.";
        console.log(error);
    }

    /*window.navigator = window.navigator || {};
    /*navigator.getUserMedia =  navigator.getUserMedia       ||
                              navigator.webkitGetUserMedia ||
                              navigator.mozGetUserMedia    ||
                              null;*/
    navigator.getUserMedia({audio:true}, soundAllowed, soundNotAllowed);

};

  }

};


</script>

<style scoped>


/* .v-input__slider, .v-select {
  width: 100%;
} */

.html, body{
width: 100%;
height: 100%;
padding: 0;
margin: 0;
background-color:#222;
font-size: 18px;
}

.spacer{
  height:20px;
}

.spacer3{
  height:10px;
}


.svg{
display: block;
width: 100%;
height: 100%;
padding: 0;
margin: 0;
position:absolute;

}

.h1{
width: 100%;
font-family: sans-serif;
position:absolute;
text-align:center;
color:white;
font-size: 18px;
top: 40%;
opacity: 1;
transition: opacity 1s ease-in-out;
-moz-transition: opacity 1s ease-in-out;
-webkit-transition: opacity 1s ease-in-out;
}




.theme-bg-card {
  color: #fff;
  padding: 10px;
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);

}

.theme-bg-card:hover {
  background: rgba(16, 22, 58, 0.5);
  outline-color: #42da91;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;
}


.theme-bg-card-2 {
  color: #fff;
  padding: 10px;
  background: rgba(66, 218, 145, 0.6);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);

}

.theme-bg-card-2:hover {
  background: rgba(66, 218, 145, 0.8);
  outline-color: #42da91;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;
}



.theme-bg-card-warning {
  background: rgba(255, 165, 0, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

.theme-bg-card-warning:hover {
  background: rgba(255, 165, 0, 0.5);
  outline-color: #42da91;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;

}


.theme-bg-card-negative {
  background: rgba(255, 0, 0, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

.theme-bg-card-negative:hover {
  background: rgba(255, 0, 0, 0.5);
  outline-color: #FF0000;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #FF0000;
	box-shadow: 0 0 5px rgba(255,0,0,.2), inset 0 0 5px rgba(255,0,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;

}

@keyframes glow {
    0% {
		border-color: #393;
		box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(120,166,156,.1), 0 2px 0 #000;
    }

    100% {
		border-color: #78b59c;
		box-shadow: 0 0 8px rgba(0,255,0,.8), inset 0 0 10px rgba(120,166,156,.4), 0 2px 0 #000;
    }
}



.text--primary{
text-align:center;
font-style:#ffffff;
font-size: 32px;
top: 40%;
opacity: 1;
border-radius: 25px;
transition: opacity 1s ease-in-out;
-moz-transition: opacity 1s ease-in-out;
-webkit-transition: opacity 1s ease-in-out;
}

.data-tiles{
text-align:center;
background: #78b59c;
font-size: 32px;
top: 40%;
opacity: 1;
border-radius: 25px;
padding: 20px;
transition: opacity 1s ease-in-out;
-moz-transition: opacity 1s ease-in-out;
-webkit-transition: opacity 1s ease-in-out;
}

.data-tiles-2{
text-align:center;
background: #78b59c;
font-size: 32px;
opacity: 1;
border-radius: 25px;
padding: 20px;
margin: 10px;
}

.data-tiles-3{
padding: 0px;
}

.h1 a{
  color: #48b1f4;
  text-decoration:none;
}

.path{
stroke-linecap: square;
stroke: white;
stroke-width: 0.5px;
}


.theme-bg {
  background: #10163a;
  color: #fff;
}


.tabbar {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    & > li {
        margin: 0 11px;
        & > svg {
            width: 14px;
            height: 14px;
            display: block;
            fill: #2F3545;
            transition: opacity .3s ease;
        }
    }
    &.open {
        & > li {
            & > svg {
                opacity: .5;
            }
        }
    }
}

.Center & dribbble
body {
    min-height: 100vh;
    font-family: Roboto, Arial;
    color: #ADAFB6;
    background: #171C28;
    display: flex;
    justify-content: center;
    align-items: center;
    .dribbble {
        position: fixed;
        display: block;
        right: 20px;
        bottom: 20px;
        img {
            display: block;
            height: 28px;
        }
    }
}

.text-color-2 {
  color: #42da91 !important;
}
.useroptions {
  background: rgba(48, 64, 87, 1);
  opacity: .85;
  color: #fff;

}
.theme-bg-2 {
  background: #10163a;
  opacity: .85;
  color: #fff;

}
.theme-bg-fy {
  background: #10163a;
  opacity: .85;
  color: #fff;
}

.menu-icon {
  background: #10163a;
  opacity: ;
  display: inline-block;
  margin-left: 40px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  right: 0px;
  margin-top: -60px;
}
.icons {
  font-size: 40px;
  color: #fff;
  margin-top: 5px;
  color: #42da91 !important;
}
.detail-card {
  width: 800px;
  height: 400px;
  background: #09435f;
  opacity: .75;
}
.db-content {
	background: linear-gradient(-45deg, #0f1724, #151f2f, #19253a, #304057);
  min-height: 140vh;
	background-size: 400% 400%;
	-webkit-animation: gradient 25s ease infinite;
	-animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
  height: 150%;
}

.mobile-view {
  display: none;
}
.desktop-view {
  display: block;
}
.three-dot {
  margin-top: 10px;
  float: right;
  color: #fff;
}
.product-animate {
  animation-name: slideleft;
  position: relative;
  animation-duration: 1.5s;
  transition: opacity 0.80s Elastic.easeOut;
}
.product-animate-out {
  animation-name: slideleft;
  position: relative;
  animation-duration: 1.5s;
  transition: opacity 0.80s Elastic.easeOut;
}
.info-animate {
  animation-name: slideleft;
  position: relative;
  animation-duration: 1.5s;
  transition: opacity 0.80s Elastic.easeOut;

}
.info-animate-out {
  animation-name: slideleft;
  position: relative;
  animation-duration: 1.5s;
  transition: opacity 0.80s Elastic.easeOut;

}
.product {
  width: 400px;
}
/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: 0px;
  }
  100% {
    left: 10px;
    top: 0px;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@media only screen and (max-width: 600px) {
  .product {
    width: 90%;
  }
  .card-margin {
    margin-top: 40px;
  }
  .mobile-view {
    display: block;
  }
  .desktop-view {
    display: none;
  }
  .db-content {
    height: 100%;
  }
  .menu-icon-2 {
    margin-left: 20px;
    color: #42da91 !important;
    margin-top: 20px;
  }
  .mb-margin {
    text-align: center;
  }
  .detail-card {
    width: 350px;
    height: 100%;
  }
}
</style>
